import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GET_USER($userId: Float!) {
    getUser(userId: $userId) {
      id
      email
      userInterests
      avatar {
        fileUrl
      }
      isOnboarded
      userConfirmed
      confirmationToken
      verified
      stripeId
      stripeAccountStatus
      userType
      skills {
        id
        name
      }
      professions {
        id
        name
      }
      profile {
        id
        name
        firstName
        lastName
        bio
        website
        collaborationStatus
        availableAt
        country
        city
      }
      desiredCollaborationProfession {
        value: id
        label: name
      }
    }
  }
`;
